import Routing from './Utils/router';
import AppIdProvider from './Contexts/AppIdProvider';

const SignatureApp = () => {
    return (
            <AppIdProvider>
                <Routing />
            </AppIdProvider>
    )
}

export default SignatureApp